import { createSlice } from "@reduxjs/toolkit";
import { fetchManagementCompanies } from "./managementSlice";

const initialState = {
  currentPage: 1,
  rowsPerPage: 10,
  totalPages: 1,
};

const paginationSlice = createSlice({
  name: "pagination",
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchManagementCompanies.fulfilled, (state, action) => {
      state.totalPages = action.payload.totalPages;
    });
  },
});

export const { setCurrentPage, setRowsPerPage, setTotalPages } =
  paginationSlice.actions;

export const selectCurrentPage = (state) => state.pagination.currentPage;
export const selectTotalPages = (state) => state.pagination.totalPages;
export const selectRowsPerPage = (state) => state.pagination.rowsPerPage;

export default paginationSlice.reducer;
